module.exports = __webpack_public_path__ + "static/media/mono_manual_panel.3f5da183.png";